import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ImageB2c } from '../../model/image.model';

@Component({
  selector: 'raf-three-sixty-image',
  templateUrl: './three-sixty-image.component.html',
  styleUrls: ['./three-sixty-image.component.scss']
})
export class ThreeSixtyImageComponent implements AfterViewInit {
  @Input() image?: ImageB2c;

  @Output() closeThreeSixty: EventEmitter<void> = new EventEmitter<void>();

  images: string[] = [];
  loadedImages = 0;
  imgLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  activeImage = 0;
  debounce = 0;
  lastDragTarget?: number;
  dragging = false;
  interval: any;
  swipeIconVisible = false;

  private MAX_ROTATIONS = 0; // 0 for infinity
  private ROTATION_SPEED = 70 // bigger is slower

  constructor(private cdr: ChangeDetectorRef) {

  }

  ngAfterViewInit() {
    this.image?.images?.forEach((img) => {
      this.images.push(img.largeUrl || "");
    });
    this.cdr.detectChanges();
  }

  drag($event: MouseEvent) {
    if (!this.dragging) {
      return;
    }
    this.move($event.clientX);
  }

  startDrag() {
    clearInterval(this.interval);
    this.dragging = true;
  }

  stopDrag() {
    this.dragging = false;
    this.lastDragTarget = undefined;
  }

  touchmove($event: TouchEvent) {
    $event.preventDefault();
    this.move($event.touches[0]?.clientX);
  }

  private move(clientX: number) {
    if (this.debounce < 2) {
      this.debounce++;
    } else {
      if (this.lastDragTarget && clientX) {
        if (clientX < this.lastDragTarget) {
          this.activeImage++;
        } else {
          this.activeImage--;
        }
        if (this.activeImage < 0) {
          this.activeImage = this.images.length - 1;
        } else if (this.activeImage === this.images.length) {
          this.activeImage = 0;
        }
      }
      this.lastDragTarget = clientX;
      this.debounce = 0;
    }
  }

  imgLoaded() {
    this.loadedImages++;
    if (this.loadedImages === this.images.length) {

      this.imgLoading.next(false);
      this.showPreview();
    }
  }

  imgError() {
    this.loadedImages++;
    if (this.loadedImages === this.images.length) {
      this.imgLoading.next(false);
      this.showPreview();
    }
  }

  close() {
    this.closeThreeSixty.emit();
  }

  private showPreview() {
    this.swipeIconVisible = true;
    const rotationsWanted = this.MAX_ROTATIONS;
    let completedRotations = 0;

    let i = 0;
    this.interval = setInterval(() => {
      this.activeImage = i;
      this.cdr.detectChanges();
      // this will keep the rotation going to infinity
      i = (i + 1) % this.images.length;

      // Check if we completed a full rotation; If 0 -> rotate to infinity
      if (rotationsWanted > 0 && i === 0) {
        completedRotations++;
        // Stop after reaching the desired number of rotations
        if (completedRotations >= rotationsWanted) {
          clearInterval(this.interval);
        }
      }
    }, this.ROTATION_SPEED);
  }
}
